/**
 * @fileoverview POST handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/message" endpoint
 */
import { reactQueryMutationAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import type { MessageType } from "@lib/campaignMessageTypeConstants";
import fetch from "@lib/fetch";

import { appGroupIdCanvasWorkflowIdStepStepIdMessageCacheKeys } from "./constants";
import type { PostAppGroupIdCanvasWorkflowIdStepStepIdMessageProps, PostMessageResult } from "./types";

export const postMessage = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdMessageCacheKeys,
  ({
    appGroupId,
    workflowId,
    stepId,
    messageType,
  }: PostAppGroupIdCanvasWorkflowIdStepStepIdMessageProps): Promise<PostMessageResult<MessageType, unknown>> => {
    // manipulate props here as needed messageType

    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step/${stepId}/message`,
      "POST",
      { message_type: messageType },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
